import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetScopeInfoQuery } from 'features/meetings/api';
import CalendarImgSrc from 'features/meetings/images/calendar.svg';
import { BOOKING_METHODS, openModal as openOneOffModal } from 'features/one_off_modal';
import { useScope } from 'hooks/meetings/use_scope';
const getScopeType = (type, id) => {
  switch (type) {
    case 'user':
      {
        if (id === 'me') {
          return 'my_calendly';
        }
        if (id) {
          return 'user_single';
        }
        return 'all_users';
      }
    case 'team':
      {
        if (id) {
          return 'page_single';
        }
        return 'page';
      }
    case 'all_users_and_teams':
      return 'all_users_and_teams';
    case 'all_users':
      return 'all_users';
    case 'user_group':
      return 'user_group';
    default:
      return null;
  }
};
const noUpcomingContainerIsPhoneCss = "n1pqv1nr";
const noUpcomingContainerCss = "n1eyvnci";
const NoUpcomingContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(noUpcomingContainerCss, {
    [noUpcomingContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const descriptionWrapperCss = "d1jwtwxo";
const DescriptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(descriptionWrapperCss, props.className)} />;
});
const BaseCard = ({
  description,
  ctaButton
}) => <NoUpcomingContainer>
    <img src={CalendarImgSrc} alt="Calendar" width="80" height="80" />
    <BodyText weight="bold">{I18n.t('publisher.meetings.end_of_list.no_upcoming_meetings')}</BodyText>
    <BodyText size="medium" color="muted">
      <DescriptionWrapper>
        {description}
      </DescriptionWrapper>
    </BodyText>
    {ctaButton}
  </NoUpcomingContainer>;
const buttonWrapperCss = "b1y2ozsj";
const ButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonWrapperCss, props.className)} />;
});
const MyCalendlyCard = () => {
  const dispatch = useDispatch();
  return <BaseCard description={I18n.t('publisher.meetings.end_of_list.we_can_change_that')} ctaButton={<ButtonWrapper>
          <Button decoration="secondary-outline" onClick={() => dispatch(openOneOffModal({
      bookingMethod: BOOKING_METHODS.instant
    }))}>
            {I18n.t('publisher.meetings.empty_state.schedule_meeting')}
          </Button>
        </ButtonWrapper>} />;
};
export const NoUpcomingMeetingsCard = () => {
  const {
    scopeId,
    scopeType: listedType
  } = useScope();
  const scopeType = getScopeType(listedType, scopeId);
  const {
    data,
    isLoading
  } = useGetScopeInfoQuery({
    scopeId,
    scopeType
  });
  if (isLoading) return null;
  switch (scopeType) {
    case 'my_calendly':
      return <MyCalendlyCard />;
    case 'user_single':
    case 'page_single':
      return <BaseCard description={I18n.t('publisher.meetings.end_of_list.named', {
        name: data?.currentScope
      })} />;
    case 'page':
      return <BaseCard description={I18n.t('publisher.meetings.end_of_list.teams')} />;
    default:
      return <BaseCard description={I18n.t('publisher.meetings.end_of_list.users')} />;
  }
};

require("./no_upcoming_meetings_card.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./no_upcoming_meetings_card.js");